<template>
    <div id="yxCenter">
        <!--banner-->
        <div class="bannerWrap">
            <video src="../../assets/video/yxCenterBanner.mp4" autoplay loop muted></video>
            <div class="conWrap">
                <h3>豪斯莱营销服务中心</h3>
                <p>致力于大数据和人工智能为核心的移动互联网广告</p>
                <p>主要赋能银行、贷款、游戏、保险等行业的营销，力争打造行业精准营销标杆</p>
                <button @click="showAlertFlag=true">立即咨询</button>
            </div>
        </div>
        <!--行业领先的数字营销服务-->
        <div class="yxfwWrap">
            <div class="headline">行业领先的数字营销服务</div>
            <div class="fwList">
                <div class="list">
                    <div class="fwTitle">专业的媒体营销推广团队</div>
                    <p class="fwCon">
                        拥有专业的市场团队深度了解客户真实需求、优化运营团队根据产品特性优化策略、设计团队打造符合产品特性的图片、视频方案、媒介团队第一时间抢占流量红利
                    </p>
                </div>
                <div class="list">
                    <div class="fwTitle">行业领先的客户资源储备</div>
                    <p class="fwCon">
                        通过多年的营销获客领域深耕，豪斯莱已和腾讯、银行、大分发商建立了深度的合作关系，其中浦发银行、广发银行、中信银行的发卡名列全行top5 </p>
                </div>
                <div class="list">
                    <div class="fwTitle">全网顶级流量精准加持</div>
                    <p class="fwCon">
                        覆盖全网合作，其中包括腾讯广告、头条、抖音、百度推广、推啊等顶级流量互动类媒体，还有华为、vivo\oppo等类别的厂商类媒体
                    </p>
                </div>
            </div>
        </div>
        <!--全网顶级流量精准加持-->
        <div class="lljcWrap">
            <div class="headline lljcWrapT" :style="titleStyle">全网顶级流量精准加持</div>
            <div class="spWrap">
                <div class="left">
                    <div class="itemBox">
                        <img src="../../assets/img/yxCenter/全网亿级流量@2x.png" alt=""/>
                        <div class="textWrap">
                            <div>全网亿级流量加持曝光</div>
                            <p>
                                覆盖全网合作，其中包括腾讯广告、头条、抖音、百度推广、推啊等顶级流量互动类媒体，还有华为、vivo\oppo等类别的厂商类媒体
                            </p>
                        </div>
                    </div>
                    <div class="itemBox">
                        <img src="../../assets/img/yxCenter/精准定向投放@2x.png" alt=""/>
                        <div class="textWrap">
                            <div>精准定向投放能力</div>
                            <p>
                                根据客户的业务需求，依托大数据技术和分析师分析，结合运营优化策略，精准定向投放内容
                            </p>
                        </div>
                    </div>
                    <div class="itemBox">
                        <img src="../../assets/img/yxCenter/线下海量@2x.png" alt=""/>
                        <div class="textWrap">
                            <div>线下海量分发资源</div>
                            <p>
                                整合市场上包含校园、社区、商场、写字楼等地推团队资源，全方位全流程获客
                            </p>
                        </div>
                    </div>
                    <div class="itemBox">
                        <img src="../../assets/img/yxCenter/客户整合@2x.png" alt=""/>
                        <div class="textWrap">
                            <div>客户整合</div>
                            <p>
                                目前已与十余家银行及大分发商建立了深度的合作关系，同时还是游戏、保险、贷款大分发商的合作伙伴
                            </p>
                        </div>
                    </div>
                    <div class="itemBox">
                        <img src="../../assets/img/yxCenter/资源整合@2x.png" alt=""/>
                        <div class="textWrap">
                            <div>资源整合</div>
                            <p>
                                已打破银行api技术对接⻔槛，目前已经逐步打通多家银行API技术对接，助力广告运营团队提升项目产能
                            </p>
                        </div>
                    </div>
                </div>
                <video src="../../assets/video/视频文件.mp4" id="spVideo" :style="videoStyle" autoplay loop muted></video>
            </div>
        </div>
        <!--专业的媒体营销推广团队-->
        <div class="tdWrap">
            <div class="headline">专业的媒体营销推广团队</div>
            <div class="serveListBox">
                <div class="serveList">
                    <img src="../../assets/img/yxCenter/营销团队@2x.png" alt=""/>
                    <div class="serveListTitle">市场营销团队</div>
                    <p>在双方合作需求上深度沟通，了解企业的真实需求，依据客户需求第一时间根据企业的实际情况调整投放策略，确保企业的价值呈增长态势</p>
                </div>
                <div class="serveList">
                    <img src="../../assets/img/yxCenter/运营团队@2x.png" alt=""/>
                    <div class="serveListTitle">运营优化团队</div>
                    <p>运营团队通过操盘数十个日消耗过十万的金融账户积累丰富的金融广告投放经验，根据产品特性，建立产品独特投放模型，保障企业的kpi要求</p>
                </div>
                <div class="serveList">
                    <img src="../../assets/img/yxCenter/设计团队@2x.png" alt=""/>
                    <div class="serveListTitle">设计团队</div>
                    <p>根据产品特性及以及实时热点，高频次地设计符合业务场景需求的高质量推广素材，打造符合受众需求的视频素材</p>
                </div>
                <div class="serveList">
                    <img src="../../assets/img/yxCenter/媒介团队@2x.png" alt=""/>
                    <div class="serveListTitle">媒介团队</div>
                    <p>及时挖掘顶级的新媒体资源，第一时间抢占高质量的流量红利，确保营销场景的触达通道快而准，保障合作企业的服务诉求</p>
                </div>
            </div>
        </div>
        <!--客户案例-->
        <div class="yhWrap">
            <div class="headline">客户案例</div>
            <!--轮播-->
            <div class="swiperWrap">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide>
                        <div class="list">
                            <img src="../../assets/img/yxCenter/中信银行@2x.png" height="440" width="540" alt=""/>
                            <div class="right">
                                <div class="rightTitle">中信银行信用卡投放策略</div>
                                <p class="rightVal">
                                    分析中信银行产品特征，中信银行信用卡的优势在于卡面极其丰富，充满多样性，比较符合年轻人的喜好需求，根据中信银行这一特点，挑选不同的卡种面向人群，定向投放对应人群，从而能更好的抓住目标客群，并且进行有价值的转化，达到最终客户要求目标，并且在这个基础上，进行多渠道的投放探索，扩大整体项目量级
                                </p>
                                <div class="mt">投放媒体<span>广点通、华为、今日头条</span></div>
                                <!--比例-->
                                <div class="blBox">
                                    <div class="blList">
                                        <div style="color: #7F31FF;">+1.5%</div>
                                        <span>（点击率）</span>
                                    </div>
                                    <span class="line"></span>
                                    <div class="blList">
                                        <div style="color: #FF7F25;">+10%</div>
                                        <span>（转化率）</span>
                                    </div>
                                </div>
                                <button @click="showAlertFlag=true">立即咨询</button>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <img src="../../assets/img/yxCenter/浦发银行@2x.png" height="440" width="540" alt=""/>
                            <div class="right">
                                <div class="rightTitle">浦发银行信用卡获客投放策略</div>
                                <p class="rightVal">
                                    根据每个渠道不同的人群属性特点，结合产品的功能特性，规划出产品媒体的受众人群，比如年龄、学历、兴趣爱好等方面，从而确定广告材料的风格特点，以此来提高各个环节的转化率，增加广告投放产出比。定期进行产品信息以及流量节日热点的结合，从而使受众对我们的广告产生新鲜度，一方面提升品牌意识，一方面促成更好的转化
                                </p>
                                <div class="mt">投放媒体<span>广点通、今日头条、搜狐汇算</span></div>
                                <!--比例-->
                                <div class="blBox">
                                    <div class="blList">
                                        <div style="color: #7F31FF;">5%</div>
                                        <span>（填表率）</span>
                                    </div>
                                    <span class="line"></span>
                                    <div class="blList">
                                        <div style="color: #FF7F25;">+10%</div>
                                        <span>（转化率）</span>
                                    </div>
                                </div>
                                <button @click="showAlertFlag=true">立即咨询</button>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <img src="../../assets/img/yxCenter/阅读@2x.png" height="440" width="540" alt=""/>
                            <div class="right">
                                <div class="rightTitle">酷匠阅读App推广投放策略</div>
                                <p class="rightVal">
                                    结合目标用户在appstore上的搜索习惯，制定产品的关键词库，并根据用户喜好和产品特性，优化了产品简介和图文介绍。通过了解竞品的投放策略，围绕产品关键词做打榜优化，并监测到榜率和新增用户数。主要的投放目标是控制获客成本；最终实现了这一目标，获得了cpa新增用户成本低至1元，比同行少150%的优秀结果
                                </p>
                                <div class="mt">投放媒体<span>Appstore</span></div>
                                <!--比例-->
                                <div class="blBox">
                                    <div class="blList">
                                        <div style="color: #7F31FF;">1元</div>
                                        <span>（用户成本）</span>
                                    </div>
                                    <span class="line"></span>
                                    <div class="blList">
                                        <div style="color: #FF7F25;">150%</div>
                                        <span>（少于同行）</span>
                                    </div>
                                </div>
                                <button @click="showAlertFlag=true">立即咨询</button>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="list">
                            <img src="../../assets/img/yxCenter/游戏@2x.png" height="440" width="540" alt=""/>
                            <div class="right">
                                <div class="rightTitle">腾讯游戏获客投放策略</div>
                                <p class="rightVal">
                                    根据游戏产品类型和策略玩法定位目标用户年龄段，地域，性别，兴趣，游戏消费能力等基础标签，结合大数据DMP精准游戏种子人群包并拓展相似游戏玩家画像，触达客户产品的目标用户和潜在用户，实现精准投放。同时配合客户在重点节假日、周年庆期间的游戏运营活动调整投放策略和节奏。目标是低于客户要求cpa，达到客户要求arpu
                                </p>
                                <div class="mt" style="margin-bottom: 16px;">投放媒体<span>广点通、今日头条、信息流</span></div>
                                <div class="mt" style="margin-bottom: 70px;">考核指标<span>留存率，付费率，付费arpu值</span></div>
                                <button @click="showAlertFlag=true">立即咨询</button>
                            </div>
                        </div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <!--合作流程-->
        <div class="hzWrap">
            <div class="headline">合作流程</div>
            <!--节点-->
            <div class="jdBox">
                <div class="jd">
                    <div class="textBox">
                        <div class="title">01</div>
                        <p>确认双方<br/>初步合作意向</p>
                    </div>
                </div>
                <div class="jd">
                    <div class="textBox">
                        <div class="title">02</div>
                        <p>产品分析</p>
                    </div>
                </div>
                <div class="jd">
                    <div class="textBox">
                        <div class="title">03</div>
                        <p>获客方式分析</p>
                    </div>
                </div>
                <div class="jd">
                    <div class="textBox">
                        <div class="title">04</div>
                        <p>推广计划执行</p>
                    </div>
                </div>
                <div class="jd">
                    <div class="textBox">
                        <div class="title">05</div>
                        <p>获客计划<br/>优化及问题反馈</p>
                    </div>
                </div>
                <div class="jd">
                    <div class="textBox">
                        <div class="title">06</div>
                        <p>放大获客空间</p>
                    </div>
                </div>
            </div>
        </div>
        <!--弹框-->
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    import 'swiper/dist/css/swiper.css'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'

    export default {
        name: "yxCenter",
        components: {
            swiper, swiperSlide
        },
        data() {
            return {
                videoStyle: {
                    position: "absolute",
                    right: 0,
                    top: "40px"
                },
                titleStyle: {
                    position: "relative",
                },
                swiperOption: {
                    autoplay: true,
                    loop: true,
                    speed: 2000,
                    // 如果需要分页器
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                },
                showAlertFlag: false
            }
        },
        created() {
            window.addEventListener('scroll', this.scrollFun);
            window.addEventListener("resize", this.scrollFun);
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        mounted() {
            this.scrollFun();
        },
        methods: {
            /*滑动事件，动态视频样式*/
            scrollFun() {
                this.$animate(document.getElementsByClassName("conWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("yxfwWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("tdWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("yhWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("hzWrap")[0], "fadeInUp");

                /*DOM元素局顶部距离*/
                let spWrapDom = document.getElementsByClassName("spWrap")[0];
                let domTop = spWrapDom.offsetTop;
                /*滑动距离*/
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let top = domTop - scrollTop + 40;
                let right = (window.innerWidth - 1200) / 2;
                /*滑动至底部，视频恢复绝对定位*/
                if (scrollTop >= 3720) {
                    this.videoStyle = {
                        position: "absolute",
                        right: 0,
                        bottom: `-110px`
                    };
                    return
                }
                /*距离顶部170时，视频开启固定定位*/
                if (top <= 170) {
                    top = 170;
                    this.videoStyle = {
                        position: "fixed",
                        right: `${right}px`,
                        top: `${top}px`
                    };
                } else {
                    this.videoStyle = {
                        position: "absolute",
                        right: 0,
                        top: "40px"
                    };
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scrollFun);
            window.removeEventListener('resize', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #yxCenter {
        .bannerWrap {
            position: relative;
            width: 100%;
            min-width: 1200px;
            height: 540px;
            margin-bottom: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: black;

            video {
                width: 100%;
                height: 100%;
                object-fit: cover;
                filter: grayscale(0%);
            }

            .conWrap {
                position: absolute;
                text-align: center;

                h3 {
                    margin-bottom: 10px;
                    font-size: 60px;
                    color: #FFFFFF;
                    text-align: center;
                }

                p {
                    opacity: 0.8;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 28px;
                }

                button {
                    width: 150px;
                    height: 48px;
                    margin-top: 44px;
                    line-height: 48px;
                    border: none;
                    outline: none;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    border-radius: 25px;
                    cursor: pointer;
                    background-image: linear-gradient(-118deg, #4161FF 0%, #1C39DC 100%);
                }
            }
        }

        .yxfwWrap {
            width: 1200px;
            margin: 0 auto 120px;

            .fwList {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .list {
                    width: 382px;
                    height: 180px;
                    padding: 30px 41px 33px;

                    &:nth-child(1) {
                        background: url("../../assets/img/yxCenter/bg-专业团队@2x.png") no-repeat center;
                        background-size: cover;
                    }

                    &:nth-child(2) {
                        background: url("../../assets/img/yxCenter/bg-客户资源@2x.png") no-repeat center;
                        background-size: cover;
                    }

                    &:nth-child(3) {
                        background: url("../../assets/img/yxCenter/bg-顶级流量@2x.png") no-repeat center;
                        background-size: cover;
                    }

                    .fwTitle {
                        margin-bottom: 12px;
                        font-size: 24px;
                        color: #FFFFFF;
                        text-align: justify;
                    }

                    .fwCon {
                        opacity: 0.8;
                        font-size: 12px;
                        color: #FFFFFF;
                        text-align: justify;
                        line-height: 24px;
                    }
                }
            }
        }

        .lljcWrap {
            width: 1200px;
            margin: 0 auto 120px;

            .headline {
                margin-bottom: 60px;
                background: #fff;
            }


            .spWrap {
                position: relative;

                .left {
                    padding-top: 430px;

                    .itemBox {
                        display: flex;
                        align-items: center;
                        margin-bottom: 430px;

                        &:last-child {
                            margin-bottom: 220px;
                        }

                        img {
                            width: 140px;
                            /*height: 100px;*/
                            /*margin-right: 30px;*/
                        }

                        .textWrap {
                            width: 360px;

                            div {
                                margin-bottom: 8px;
                                font-size: 36px;
                                color: #152346;
                                text-align: justify;
                            }

                            p {
                                opacity: 0.6;
                                font-size: 14px;
                                color: #152346;
                                text-align: justify;
                                line-height: 24px;
                            }
                        }
                    }
                }

                video {
                    width: 640px;
                    height: 400px;
                    object-fit: cover;
                    filter: grayscale(0%);
                }
            }
        }

        .tdWrap {
            width: 1200px;
            margin: 0 auto;

            .serveListBox {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 120px;

                .serveList {
                    width: 500px;
                    margin-bottom: 14px;

                    &:nth-child(3), &:nth-child(4) {
                        margin-bottom: 0;
                    }

                    img {
                        width: 50px;
                        height: 50px;
                        margin-bottom: 8px;
                    }

                    .serveListTitle {
                        margin-bottom: 10px;
                        font-size: 16px;
                        line-height: 22px;
                        color: #152346;
                    }

                    p {
                        opacity: 0.6;
                        font-size: 12px;
                        color: #152346;
                        text-align: justify;
                        line-height: 24px;
                    }
                }
            }
        }

        .yhWrap {
            width: 100vw;
            margin: 0 auto 120px;

            .swiperWrap {

                .list {
                    width: 1200px;
                    height: 440px;
                    margin: 0 auto;
                    display: flex;
                    border-radius: 16px;
                    box-shadow: 0 16px 35px 0 #ccc;


                    img {
                        display: inline-block;
                        width: 540px;
                    }

                    .right {
                        flex: 1;
                        height: 440px;
                        display: inline-block;
                        padding: 40px 50px 45px 40px;

                        .rightTitle {
                            margin-bottom: 8px;
                            font-size: 32px;
                            color: #152346;
                            text-align: justify;
                        }

                        .rightVal {
                            margin-bottom: 24px;
                            opacity: 0.6;
                            font-size: 12px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;
                        }

                        .mt {
                            display: flex;
                            align-items: center;
                            margin-bottom: 20px;
                            font-size: 18px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;

                            span {
                                display: inline-block;
                                margin-left: 8px;
                                opacity: 0.6;
                                font-size: 12px;
                                color: #152346;
                                line-height: 24px;
                            }
                        }

                        .blBox {
                            display: flex;
                            align-items: center;
                            margin-bottom: 40px;

                            .line {
                                display: inline-block;
                                width: 1px;
                                height: 40px;
                                margin: 0 20px;
                                opacity: 0.2;
                                background: #D8D8D8;
                            }

                            .blList {
                                text-align: center;

                                div {
                                    font-size: 24px;
                                }

                                span {
                                    opacity: 0.6;
                                    font-size: 12px;
                                    color: #152346;
                                }
                            }
                        }

                        button {
                            width: 150px;
                            height: 48px;
                            font-size: 16px;
                            color: #FFFFFF;
                            text-align: center;
                            cursor: pointer;
                            background-image: linear-gradient(118deg, #4161FF 0%, #1C39DC 100%);
                            border-radius: 25px;
                        }
                    }
                }
            }
        }

        .hzWrap {
            width: 1200px;
            margin: 0 auto 280px;

            .jdBox {
                position: relative;
                display: flex;
                align-items: center;
                height: 2px;
                padding: 0 40px;
                background: #E6EAF4;

                .jd {
                    position: relative;
                    width: 30px;
                    height: 30px;
                    margin-right: 170px;
                    background: url("../../assets/img/yxCenter/节点.png");
                    background-size: cover;

                    &:last-child {
                        margin-right: 0;
                    }

                    .textBox {
                        position: absolute;
                        top: 24px;
                        left: 10px;

                        .title {
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #FF7F25;
                        }

                        p {
                            width: 98px;
                        }
                    }
                }
            }
        }
    }
</style>